import { TenantsApiEndpoints } from '@contracts';

export const TENANTS_ENDPOINTS: TenantsApiEndpoints = {
   list: {
    path: 'tenants/',
    version: 'v1',
    domain: 'core',
  },
  create: {
    path: 'tenants/',
    version: 'v1',
    domain: 'core',
  },
  update: {
    path: 'tenants/',
    version: 'v1',
    domain: 'core',
  },
  delete: {
    path: 'tenants/',
    version: 'v1',
    domain: 'core',
  },
  dictionary: {
    path: 'get/dictionary?type=en-US',
    version: 'v1',
    domain: 'core',
  },
};
